module.exports = __webpack_public_path__ + "img/op_como-funciona-relink-4.c8826a2.png";